import { render, staticRenderFns } from "./InspectProject.vue?vue&type=template&id=2e979466&scoped=true&"
import script from "./InspectProject.vue?vue&type=script&lang=ts&"
export * from "./InspectProject.vue?vue&type=script&lang=ts&"
import style0 from "./InspectProject.vue?vue&type=style&index=0&id=2e979466&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e979466",
  null
  
)

export default component.exports